exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".postDeletionSurvey__button___1xaM1 {\n  padding: 4px 25px;\n  font-weight: bold;\n  height: 54px; }\n  .postDeletionSurvey__button___1xaM1.postDeletionSurvey__skipButton___3NKfo {\n    color: #828282 !important; }\n\n.postDeletionSurvey__reasons____xp0X .ant-radio-wrapper {\n  display: flex;\n  align-items: center;\n  margin-right: 0;\n  white-space: normal;\n  margin-bottom: 6px; }\n\n.postDeletionSurvey__reasons____xp0X .ant-radio {\n  flex-shrink: 0; }\n", ""]);

// exports
exports.locals = {
	"button": "postDeletionSurvey__button___1xaM1",
	"skipButton": "postDeletionSurvey__skipButton___3NKfo",
	"reasons": "postDeletionSurvey__reasons____xp0X"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"sourceMap":false,"minimize":true,"importLoaders":2,"localIdentName":"[name]__[local]___[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js?{"includePaths":["./src"]}!./src/components/PostDeletionSurvey/postDeletionSurvey.scss
// module id = 4569
// module chunks = 6